import React, { createContext, useContext, useState } from "react";
import { getPresentationJobsAPICall } from "../api/presentations/presentationService";
import { useProjectContext } from "./useProjectContext";

const PresentationContext = createContext();

export const usePresentationContext = () => useContext(PresentationContext);

export default function PresentationContextProvider({ children }) {
  const { selectedProject } = useProjectContext();

  const [presentationJobs, setPresentationJobs] = useState([]);
  const [isPresentationsLoading, setIsPresentationsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);

  const loadPresentationJobs = (page = 1, itemsPerPage = 20, dateFilters = {}) => {
    if (!selectedProject?.id) return;

    setIsPresentationsLoading(true);
    getPresentationJobsAPICall(
      selectedProject.id,
      page,
      itemsPerPage,
      (response) => {
        setPresentationJobs(response.data?.presentation_jobs || []);
        setTotalPages(response.data?.pagination?.total_pages || 1);
        setIsPresentationsLoading(false);
      },
      () => {
        setIsPresentationsLoading(false);
      },
      dateFilters
    );
  };

  return (
    <PresentationContext.Provider value={{ presentationJobs, isPresentationsLoading, totalPages, loadPresentationJobs }}>
      {children}
    </PresentationContext.Provider>
  );
}
